/**
 * @file コンポーネント：ノート削除モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "cancel",
                    onClick: (e) => props.fnOnClickCancel(e),
                    text: localized["Label.Cancel"],
                },
                {
                    buttonType: "caution",
                    onClick: (e) => props.fnOnClickDelete(e),
                    text: localized["Label.Delete"],
                },
            ]}
            content={[
                <Paragraph
                    key="modal"
                    onColor="white"
                    text={localized["Label.DeleteMessage"]}
                />,
            ]}
            hasButtonClose={true}
            headline={localized["Label.DeleteNote"]}
            isShow={props.isOpenModal}
            setIsShow={props.setIsOpenModal}
        />
    );
};
